const day = (value) => {
  const text = String(value || '').slice(0, 10);
  return /^\d{4}-\d{2}-\d{2}$/.test(text) ? text : '';
};

/** Belegung schneidet den Fußleisten-Zeitraum. Leeres Ende gilt als offen. */
export function enrollmentVisibleInFooter(enrollment, footer) {
  if (!footer) return true;
  const start = day(enrollment?.start_date);
  const end = day(enrollment?.end_date);
  if (footer.nurAktive && enrollment?.status && enrollment.status !== 'active') return false;
  if (footer.zeitraumOn) {
    if (footer.von && end && end < footer.von) return false;
    if (footer.bis && start && start > footer.bis) return false;
  }
  if (footer.stichtagOn && footer.stichtag && end && end < footer.stichtag) return false;
  return true;
}
